<template>
  <a-modal
    :visible.sync="isVisible"
    :okButtonProps="{ props: {disabled: false} }"
    :maskClosable="false"
    :bodyStyle="isMobile() ? { margin: 'auto 20px' } : { margin: 'auto 50px' }"
    title="编辑用户"
    @cancel="handleCancel">
    <template slot="footer">
      <a-button :loading="resetLoading" type="danger" style="float:left;" @click="handleReset">重置密码</a-button>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button :loading="loading" key="submit" type="primary" @click="handleOk">保存</a-button>
    </template>
    <a-form :form="form">
      <a-form-item label="账号" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-input
          disabled
          v-decorator="['username']">
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item label="角色" :labelCol="{ span: 5 }" :wrapperCol="{ span: 17 }">
        <a-select
          mode="multiple"
          placeholder="请选择角色"
          style="width:100%;"
          v-decorator="[ 'roles', { rules: [{ required: true, message: '至少选择一种角色' }] } ]">
          <a-select-option v-for="role in roles" :key="role">
            {{ role }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item v-show="isAdmin" label="所属企业" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-select
          placeholder="键入名字选择企业"
          :filterOption="false"
          showSearch
          @search="loadCorps"
          :notFoundContent="corpLoading ? undefined : '没有符合的企业'"
          v-decorator="['corp', {
            rules: [{ required: true, message: '企业不能为空' }]
          }]">
          <a-spin v-if="corpLoading" slot="notFoundContent" size="small"/>
          <a-select-option v-for="item in corps" :key="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="姓名" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-input
          placeholder="输入用户姓名"
          v-decorator="['realname', {
            rules: [{ required: true, message: '用户姓名不能为空' },
                    { pattern: /^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z]){2,20}$/, message: '姓名限制2-20个中英文字符' }],
            validateTrigger: 'blur'
          }]"/>
      </a-form-item>

      <a-form-item label="手机号码" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-input
          placeholder="输入手机号码"
          v-decorator="['mobile', {
            rules: [{ required: true, pattern: /^1[345789]\d{9}$/, message: '请输入正确的手机号码' }]
          }]"/>
      </a-form-item>

      <a-form-item label="邮箱" :labelCol="{ sm: 8, md: 5 }" :wrapperCol="{ sm: 16, md: 18 }">
        <a-input
          placeholder="输入邮箱"
          v-decorator="['email', {
            rules: [{ required: true, type: 'email', message: '请输入正确的邮箱地址' }]
          }]"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { updateUser, restorePassword } from '@/api/user'
import { pageCorp } from '@/api/corp'
import { mixinDevice } from '@/utils/mixin'

export default {
  mixins: [mixinDevice],

  props: {
    visible: {
      required: true,
      type: Boolean
    },

    roles: {
      required: true,
      type: Array
    },

    isAdmin: {
      required: true,
      type: Boolean
    }
  },

  data () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      resetLoading: false,
      userId: '',
      corpLoading: false,
      corps: []
    }
  },

  computed: {
    isVisible: {
      get: function () {
        return this.visible
      },
      set: function (val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    onLoad (user) {
      if (user && user.id) {
        this.userId = user.id
        this.corps = [{ id: user.corpId, name: user.corpName }]
        setTimeout(() => {
          this.form.setFieldsValue({ 'username': user.username })
          this.form.setFieldsValue({ 'realname': user.realname })
          this.form.setFieldsValue({ 'mobile': user.mobile })
          this.form.setFieldsValue({ 'email': user.email })
          this.form.setFieldsValue({ 'corp': user.corpId })
          this.form.setFieldsValue({ 'roles': user.roles })
        }, 0)
        this.loadCorps()
      } else {
        this.$message.error('获取用户信息失败')
        this.isVisible = false
      }
    },

    handleOk () {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          values.corpId = values.corp
          values.corp = null // 无需提交
          updateUser(this.userId, values).then(response => {
            this.$message.success(response.msg)
            this.isVisible = false
            this.$emit('onUpdated')
          }).catch(err => {
            console.log(err)
          }).finally(() => {
            this.loading = false
          })
        } else {
          console.log(err)
          this.loading = false
        }
      })
    },

    handleCancel () {
      this.isVisible = false
    },

    loadCorps (val) {
      this.corpLoading = true
      const query = {
        name: val,
        pageSize: 50,
        pageNumber: 0
      }
      pageCorp(query).then(response => {
        this.corps = response.data.content
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.corpLoading = false
      })
    },

    handleReset () {
      this.resetLoading = true
      restorePassword(this.userId).then(response => {
        this.$emit('onPasswordRestored', response.data)
        this.isVisible = false
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.resetLoading = false
      })
    }
  }
}
</script>

<style scoped>
</style>
